import { render, staticRenderFns } from "./TeacherFeedback.vue?vue&type=template&id=6b320fc5&scoped=true"
import script from "./TeacherFeedback.vue?vue&type=script&lang=js"
export * from "./TeacherFeedback.vue?vue&type=script&lang=js"
import style0 from "./TeacherFeedback.vue?vue&type=style&index=0&id=6b320fc5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b320fc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b320fc5')) {
      api.createRecord('6b320fc5', component.options)
    } else {
      api.reload('6b320fc5', component.options)
    }
    module.hot.accept("./TeacherFeedback.vue?vue&type=template&id=6b320fc5&scoped=true", function () {
      api.rerender('6b320fc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/TeacherFeedback.vue"
export default component.exports